import { I18n } from '@calendly/i18n'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { useViewportSize } from '@calendly/ui/hooks/viewport-size-context'
import { useCallback } from 'react'

import { CrudAvailability } from 'features/event_type_editor'

import { AdditionalSettingsSection } from './additional_settings_section'
import { BookingExceptionsSection } from './booking_exceptions_section'
import { SchedulingWindowSection } from './scheduling_window_section'
import {
  dividerCss,
  mainContentCss,
  pageHeaderCss,
  settingsCss,
} from './styles'
import {
  EDITOR_PREVIEW_MODES,
  useEditorPreviewActions,
  useEditorPreviewState,
} from '../../components/editor_preview_context'

export const AvailabilityTabPanel = ({
  isLocked = false,
  isReadOnly = false,
}) => {
  const { isLargeViewport } = useViewportSize()
  const { mode, calendarFormPath } = useEditorPreviewState()
  const { toggleAvailabilityCalendar, showDefaultPreview } = useEditorPreviewActions()
  const onViewCalendarInPreview = useCallback((formPath) => {
    toggleAvailabilityCalendar(formPath)
  }, [toggleAvailabilityCalendar])
  const isCalendarPreviewActive = (
    isLargeViewport
    && mode === EDITOR_PREVIEW_MODES.calendar
    && Boolean(calendarFormPath)
  )

  return (
    <div className={mainContentCss} data-testid="availability-tab-panel">
      <header className={pageHeaderCss}>
        <TitleText level={2} size="large">
          {I18n.t('publisher.event_type_editor_crud.availability.page_title')}
        </TitleText>
        <BodyText color="muted" size="large">
          {I18n.t('publisher.event_type_editor_crud.availability.page_description')}
        </BodyText>
      </header>

      <div className={settingsCss} data-testid="availability-tab-content">
        <CrudAvailability
          isLocked={isLocked}
          isReadOnly={isReadOnly}
          onViewCalendarInPreview={isLargeViewport ? onViewCalendarInPreview : undefined}
          isCalendarPreviewActive={isCalendarPreviewActive}
          onClearCalendarPreview={isLargeViewport ? showDefaultPreview : undefined}
          variant="v4"
        />
        <SchedulingWindowSection isLocked={isLocked || isReadOnly} />
        <div className={dividerCss} role="presentation" />
        <BookingExceptionsSection />
        <div className={dividerCss} role="presentation" />
        <AdditionalSettingsSection isLocked={isLocked || isReadOnly} />
      </div>
    </div>
  )
}
